const SENTRY_URL = ''

const envs = {
  local: {
    ENV: 'local',
    API_BASE: 'http://local.cleverbuild.biz:8080'
  },
  dev: {
    ENV: 'development',
    SENTRY_URL,
    API_BASE: 'https://gtech-gravity-api-dev-exmklu.cleverbuild.biz'
  },
  stage: {
    ENV: 'staging',
    API_BASE: 'https://gtech-gravity-api-stage-gesbfls.cleverbuild.biz',
    SENTRY_URL
  },
  prod: {
    ENV: 'production',
    API_BASE: 'https://gtech-gravity-api-prod-gesbfls.cleverbuild.biz',
    SENTRY_URL: 'https://a8a20516d6f34737b7cee69a0c903026@sentry.cleverbuild.biz/45'
  },
  gtech: {
    ENV: 'production',
    API_BASE: 'https://gravity-api.g-ta.com',
    SENTRY_URL
  }
}

// Expected hosts:
// local  :      local.cleverbuild.biz
// dev    :   dev-<random>.example.com
// staging: stage-<random>.example.com
// prod   :                example.com

const localHostnames = ['local.cleverbuild.biz', 'localhost', '127.0.0.1']

const calculateConfig = () => {
  const { hostname } = window.location
  if (localHostnames.indexOf(hostname) >= 0) return envs['local']

  if (hostname.indexOf('g-ta.com') >= 0) return envs['gtech']

  const subdomain = hostname.split('.')[0]
  const names = subdomain.split('-')
  const env = names[names.length - 2]
  const config = envs[env]

  return config
}

const config = calculateConfig()
if (config.SENTRY_URL) {
  Raven.config(config.SENTRY_URL).install() // eslint-disable-line
  Raven.setTagsContext({ environment: config.ENV }) // eslint-disable-line
  // Raven.captureException(new Error('test'), { extra: 'extra info' }) // eslint-disable-line
}
export default calculateConfig()



// WEBPACK FOOTER //
// ./src/config.js